import React from "react";
import Pic from "./Pic";
import Social from "./Social";

const Footer = ({ data }) => {
    return (
        <div id="footer" className="flex w-[98%] mx-auto mt-4 lg:flex-row md:flex-row flex-col justify-between lg:h-[429px] md:h-[468px] md:p-4 p-2 lg:gap-14 md:gap-8 gap-14">

            <Pic data={data} />

            <div className="flex flex-col gap-14 justify-between font-medium">

                <div className="flex lg:flex-row flex-col  justify-between lg:gap-0 md:gap-10 gap-14" style={{ color: data.text }}>

                    <div className="flex justify-between md:flex-row flex-col lg:p-0 gap-14 ">

                        <div className="flex flex-col lg:text-[20px] md:text-[16px] text-[20px] lg:gap-9 md:gap-7 gap-5 w-fit">
                            <a href={`tel:${data.numberLink}`}>{data.number}</a>
                            <span>{data.email_address}</span>
                            <span>{data.address}</span>
                        </div>

                        <div className="h-[168px] text-[16px] md:justify-between gap-16 lg:gap-20 md:gap-8 flex">

                            <div className="flex flex-col gap-8">
                                <a href="#about-us">О нас</a>
                                <a href="#services">Услуги</a>
                                <a href="/calculator">Калькулятор</a>
                                <a href="/cases">Кейсы</a>
                            </div>

                            <div className="flex flex-col gap-8">
                                <a href="/blog">Новости</a>
                                <a href="#footer">Контакты</a>
                                <a href="#offices">Офисы и склады</a>
                            </div>

                        </div>

                    </div>

                    <Social data={data} />

                </div>

                <div className="flex justify-between p lg:gap-0 md:gap-4 lg:flex-row flex-col lg:items-center md:items-start md:text-[16px] text-[14px]" style={{ color: data.text_grey }}>

                    <span className="lg:order-first order-last">{data.name_company}</span>

                    <div className="flex lg:order-last order-first items-center gap-12">
                        <a href="public/docs/Договор экспедирования ЮЛА.pdf" download="public/docs/Договор экспедирования ЮЛА.pdf"> {data.requisites} </a>
                        <a href="public/docs/Соглашение об обработке персональных данных.pdf" download="./docs/Соглашение об обработке персональных данных.pdf"> {data.privacy_policy} </a>
                    </div>

                </div>

            </div>

        </div>
    );
};

export default Footer;